import { __assign } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './loader.scss';
export var Loader = function (_a) {
    var _b, _c, _d;
    var _e = _a.bubbleClassName, bubbleClassName = _e === void 0 ? 'forum-text-background-color' : _e, _f = _a.containerProps, containerProps = _f === void 0 ? {} : _f, _g = _a.small, small = _g === void 0 ? false : _g;
    return (React.createElement("div", __assign({ className: styles.container }, containerProps),
        React.createElement("span", { className: classNames(styles.dot, (_b = {}, _b[styles.small] = small, _b), bubbleClassName) }),
        React.createElement("span", { className: classNames(styles.dot, (_c = {}, _c[styles.small] = small, _c), bubbleClassName) }),
        React.createElement("span", { className: classNames(styles.dot, (_d = {}, _d[styles.small] = small, _d), bubbleClassName) })));
};
Loader.propTypes = {
    bubbleClassName: PropTypes.string,
    containerProps: PropTypes.object,
    small: PropTypes.bool,
};
//# sourceMappingURL=loader.js.map